module.exports = __webpack_public_path__ + "img/uparrow.c4acccad.svg";